/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/481-file-openoffice': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10.785 7.37c-.948-.448-2.156-.538-3.044.095 1.08-.103 2.265.076 3.049.893.75-.861 1.939-1.022 3.015-.933-.898-.596-2.082-.516-3.019-.054zm-.384 2.095c-1.068-.025-2.101.362-2.986.939-1.675-.712-3.793-.58-5.219.609.411-.015.813-.116 1.22-.169 1.487-.148 3.072.221 4.196 1.247a4.52 4.52 0 011.87-1.561c.986-.477 2.096-.526 3.169-.539-.651-.448-1.478-.531-2.249-.526z"/><path pid="1" d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"/>'
  }
})
